<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Budgets</h4>
                    </div>
                    <div class="page-btn d-flex">
                        <a  *ngIf="accessControlService.canWrite('Common Upload')" class="btn btn-added ms-3" (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Budget</a>
                        <button *ngIf="accessControlService.canWrite('Budget')" class="btn btn-added" (click)="addBudget('Add')">+Add</button>
                        <div class="col" style="padding-left: 0;">
                            <app-export-btn [selectedRows]="selectedRows" [allColumns]="columns" [fileName]="'Budget'" [exportApi]="getListExportApi"
                            [exportParams]="{ filters: filters, sortingCol: sortingCol, direction: direction }"></app-export-btn>
                        </div>                              
                    </div>
                </div>


                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <app-filter [warehouseList]="warehouseList" [showCustomerAndWarehouse]="true" [accounts]="accounts" [showFY]="true" [showMonth]="true" [showBudgetType]="true"
                                    [showExpenseType]="true"  (filterChange)="onFilterChange($event)"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <ng-container *ngIf="accessControlService.canWrite('Common Upload')" >
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedData?.length ?? 0) > 0" (click)="editEvent()">Edit</a>
                                </ng-container>
                                <!-- <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a> -->
                            </div>

                        </div>

                        <app-shared-table [componentName]="'budget'" [columns]="columns" [tableName]="tableName" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)">
                        </app-shared-table>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div>
            </div>
        </div>
    </div>
</div>